module.exports = __webpack_public_path__ + "media/icons-lj-styleguide-2025/info-5e5bdb8c.svg";